import { render, staticRenderFns } from "./SetIndexUrl.vue?vue&type=template&id=5d8478a0&scoped=true"
import script from "./SetIndexUrl.vue?vue&type=script&lang=js"
export * from "./SetIndexUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8478a0",
  null
  
)

export default component.exports